<template>
    <div id="company-order-status" style="margin: 10px;">
        <div class="board-header">
            <div class="btn-logout" @click="logout">登出</div>
            <div class="btn-refresh" @click="refresh">手動刷新</div>
            <div class="need-work">待領單數 <span style="color: red;">{{ need_work_qty }}</span> 筆</div>
            <div>更新時間 {{ update_datetime }}</div>
        </div>
        <GridTable
            :rows="gdt.rows.getData()"
            :columns="gdt.columns.getData()"
            :onRowClick="onRowClick"
            :rowStyleClassFn="rowStyleClassFn"
            :max-height=150
        >
        </GridTable>

        <GridTable
            :rows="gdt2.rows.getData()"
            :columns="gdt2.columns.getData()"
            :max-height=150
        >
        </GridTable>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from '@vue/composition-api'
import DateManager from '@/sag-core/other/DateManager.js'
import core from '@/sag-core/grid_table/core.js'
import refData from '@/sag-core/grid_table/refData.js'
import GridTable from '@/sag-core/grid_table/GridTable.vue'
import api from'./api.js'
import utils from '@/sag-core/utils.js'
import { logout } from '@/router'
export default {
    name: 'CompanyOrderStatus',
    components: {
        GridTable,
    },
    props: {

    },
    setup(){
        let source = null;
        let current = null;
        let need_work_qty = ref(0);
        let interval = null;
        let update_datetime = ref('');

        

        const gdt = new core.GridDataTable(new refData.RefDataCreator());
        const gdt2 = new core.GridDataTable(new refData.RefDataCreator());
        

        // const tsas = new core.TestApiSubscriber();
        // const tsas2 = new core.TestApiSubscriber();
        // tsas2.changeTestData(0);
        // const tsas3 = new core.TestApiSubscriber();
        // tsas3.changeTestData(1);
        const as = new core.ApiSubscriber();
        const as2 = new core.ApiSubscriber();
        // const as2_2 = new core.ApiSubscriber();
        // const as3 = new core.ApiSubscriber();
        gdt.subscribe('api', as); // 訂閱事件
        gdt2.subscribe('api', as2); // 訂閱事件
        // gdt.subscribe('api3', as3); // 訂閱事件
        // gdt.subscribe('test-api', tsas); // 訂閱事件
        // gdt.subscribe('test-api2', tsas2); // 訂閱事件
        // gdt.subscribe('test-api3', tsas3); // 訂閱事件


        // gdt2.subscribe('test-api', tsas); // 訂閱事件
        // gdt2.subscribe('api2', as2); // 訂閱事件

        // gdt2.recognizeFather(gdt);

        as.readData = ()=>{
            return new Promise((res, rej)=>{
                api.GetCompanyOrder(utils.getUserData().companyCode).then(response=>{
                    source = response;
                    res(source.Head);
                    current = source.Head[0];
                    gdt2.readData('api');
                    
                    need_work_qty.value = source.Head.filter(p=>!p.DeliveryDateTime).length
                });
            })
        }

        as2.readData = ()=>{
            // console.log(current.TA001, current.TA002, source.Body.filter(p=>p.TA001 === current.TA001 && p.TA002 === current.TA002));
            return source.Body.filter(p=>p.TA001 === current.TA001 && p.TA002 === current.TA002);
            // return source.Body
        }

        // as2.rowDataOperation = (event)=>{
        //     if(event instanceof core.GridDataTable){
        //         return event.rows.getData().sort((a, b)=> {
        //             return parseInt(a.Employee_WorkCode) - parseInt(b.Employee_WorkCode);
        //         });
        //     }
        // }
        // as3.rowDataOperation = (event)=>{
        //     if(event instanceof core.GridDataTable){
        //         return event.rows.getData().sort((a, b)=> {
        //             return parseInt(b.Employee_WorkCode) - parseInt(a.Employee_WorkCode);
        //         });
        //     }
        // }

        gdt.columns.getData().splice(0, 0, ...[ // 設定 column
                new core.Column('KickOff', '領料時間').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA001', '製令單別').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA002', '製令編號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA006', '產品品號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA034', '產品品名').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA035', '產品規格').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA007', '單位').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA009', '預計開工').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA015', '預計產量').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA022', '加工單價').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA023', '加工單位').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA032', '加工廠商').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MA002', '加工廠商名稱').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA042', '幣別').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA043', '匯率').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'), 
                // new core.Column('DeliveryDateTime', '自動倉吐料時間').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
            ]);

        gdt2.columns.getData().splice(0, 0, ...[ // 設定 column
                new core.Column('TA001', '製令單別').SetMiddle().SetHidden().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('TA002', '製令編號').SetMiddle().SetHidden().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MB001', '品號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MB002', '品名').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MB003', '規格').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MB004', '庫存單位').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MB010', '標準途程品號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'), 
                new core.Column('MB011', '標準途程代號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MC001', '庫別代號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MC002', '庫別名稱').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MW001', '製程代號').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MW002', '製程名稱').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
                new core.Column('MC007', '備註').SetMiddle().SetWidth(150).SetCellClass('text-nowrap'),
            ]);

        const onRowClick = (event)=>{
            current = event.row;
            console.log('onRowClick', event, current);

            gdt2.readData('api');
        }

        const rowStyleClassFn = (row)=>{
            return row.DeliveryDateTime ? 'work' : 'no-work'
        }

        const refresh = ()=>{
            gdt.readData('api');
            update_datetime.value = new DateManager().now();
        }

        refresh();

        onMounted(()=>{
            interval = setInterval(()=>{
                refresh();
            }, 24 * 60 * 60 * 1000);
        })

        onUnmounted(()=>{
            clearInterval(interval);
        })

        return {
            gdt,
            gdt2,
            logout,
            onRowClick,
            rowStyleClassFn,
            need_work_qty,
            update_datetime,
            refresh,
        }
    }
}
</script>

<style lang="scss">
.board-header {
    display: flex;
    // justify-content: center;
    align-items: center;
    gap: 20px;
}

.btn-logout, .btn-refresh {
    user-select: none;
    cursor: pointer;
    margin: 10px;
    padding: 5px;
    text-align: center;
    border: 1px solid black;
    border-radius: 3px;
    justify-content: center;
}

.need-work {
    
}

.no-work {
    background-color: rgb(255, 220, 226);
    &:hover {
        background-color: pink !important;
    }
}



</style>